import { Pagination } from "~/extensions/api";
export class AbstractStore {
    /** 検索条件 */
    condition;
    /** 最後に検索を実行した時の検索条件 */
    storedCondition;
    /** 検索条件入力検証オブジェクト */
    conditionValid;
    /** 検索結果一覧のデフォルトページング情報 */
    defaultPagination;
    /** 検索結果一覧のページング情報 */
    pagination;
    /** 検索結果一覧の表示データ一覧 */
    results = [];
    /** 検索実行日時 */
    foundDate = "";
    /** 検索実行済フラグ */
    isFind = false;
    /**
     * ストアが初期化済か否かを判定します。
     */
    get isInitialized() {
        return this.condition != null;
    }
    /**
     * ページング情報をデフォルトの内容に初期化します。
     */
    resetPagination() {
        if (this.defaultPagination === null) {
            this.defaultPagination = new Pagination(this.keyName, false);
        }
        this.pagination = new Pagination(this.keyName, false);
        this.pagination.copyFrom(this.defaultPagination);
    }
    /**
     * 指定した検索条件をストアにセットします。
     */
    setCondition(target) {
        this.storedCondition.copyFrom(target);
    }
    /**
     * ストアで管理している情報を初期化します。
     */
    clear() {
        this.condition?.clear();
        this.storedCondition?.clear();
        this.resetPagination();
        this.results = [];
        this.foundDate = "";
        this.isFind = false;
    }
}
